<template>
	<div class="contact_us">
		<span class="email">
			联系邮箱: support@bytelang.com
		</span>
	</div>
</template>

<script>
	export default {
		name: "contact_us"
	}
</script>

<style scoped lang="less">
	@import "../../../src/theme/default";
	
	.contact_us {
		font-size: 15px;
		padding: 50px 0;
		text-align: center;
		
		.email {
			font-size: 15px;
			padding: 4px 0;
			border-bottom: 1px solid @primary-color;
		}
	}
</style>